/**
 * SaldoTotalWidget — Saldo agregado das contas financeiras ativas.
 *
 * Permissao: financeiro:view. Fonte: GET /api/financeiro/resumo.
 * Drill-down: link para /financeiro/dashboard.
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterResumoFinanceiro } from "../../../services/financeiro";
import { formatarReaisBR, plural } from "../../../utils/dinheiro";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "saldo_total",
  label: "Saldo total (Financeiro)",
  descricao: "Soma do saldo atual de todas as contas financeiras ativas.",
  categoria: "Financeiro",
  permissoes: ["financeiro:view"],
  tamanho_default: "S",
  essencial: true,
};

export async function fetchData(request) {
  const r = await obterResumoFinanceiro(request);
  return r || null;
}

function fmtMoeda(v) {
  if (v === null || v === undefined) return "—";
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return formatarReaisBR(n);
}

export function Widget({ dados }) {
  // V40 (auditoria 2026-08-07): o widget mostrava "—" enquanto
  // /financeiro/dashboard mostrava R$ 356 mil, com os DOIS lendo o mesmo
  // endpoint. A tela lia `saldo_total`; o payload publica
  // `saldo_total_atual`. Chave errada não dá erro em JavaScript — dá
  // `undefined`, que aqui virava travessão e passava por "não configurado".
  const saldo =
    dados?.saldo_total_atual ?? dados?.saldo_total ?? dados?.saldo ?? null;
  const contas = Array.isArray(dados?.contas) ? dados.contas : [];

  return (
    <>
      <CardBody>
        <KpiValor>{fmtMoeda(saldo)}</KpiValor>
        <KpiSub>
          {contas.length > 0
            ? `${plural(contas.length, "conta ativa", "contas ativas")}`
            : "Soma de todas as contas"}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/financeiro/dashboard">Ver Financeiro</LinkLight>
      </CardFooter>
    </>
  );
}
